<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(title="Assign balance to invoice" @close="onClose")

      yz-dialog-normal-content.px-6.py-6
        .text-neutral-700
          .yz-medium-body-md.mb-2 Are you sure you want to assign this balance to the selected invoice?
          .yz-regular-body-sm.mb-4 The remaining balance will be added as amount due for the invoice below.

          // Invoice details section
          .yz-medium-body-xs.mb-2 Invoice details:

          yz-card.pa-3(outlined, color="yz-neutral-200")
            template(v-if="type === 'single'")
              v-row(no-gutters)
                v-col(cols="6")
                  .yz-medium-body-sm.text-neutral-500 Patient name
                v-col(cols="6")
                  .yz-medium-body-sm {{ patientName || 'N/A' }}
              v-row.mt-3(no-gutters)
                v-col(cols="6")
                  .yz-medium-body-sm.text-neutral-500 Invoice number
                v-col(cols="6")
                  .yz-medium-body-sm {{ invoiceNumber || 'N/A' }}
            template(v-if="type === 'bulk'")
              v-row(no-gutters)
                v-col(cols="6")
                  .yz-medium-body-sm.text-neutral-500 Total invoices
                v-col(cols="6")
                  .yz-medium-body-sm 10 invoices
            // Outstanding amount row for both single and bulk types
            v-row.mt-3(no-gutters)
              v-col(cols="6")
                .yz-medium-body-sm.text-neutral-500 Outstanding Amount
              v-col(cols="6")
                .yz-medium-body-sm {{ outstandingAmount | displayPrice($currency) }}

          .yz-regular-body-sm.mt-4 Click "Confirm" to proceed.

      yz-dialog-normal-actions
        .d-flex.align-center.gap-3.justify-end
          yz-btn(size="lg" text label="Cancel" @click="onCancel")
          yz-btn(size="lg" label="Confirm" color="primary" @click="onConfirm")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ['single', 'bulk'].includes(value)
    },
    patientName: {
      type: String,
      default: ''
    },
    invoiceNumber: {
      type: [String, Number],
      default: ''
    },
    outstandingAmount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirmed')
    },
    onCancel() {
      this.$emit('canceled')
      this.onClose()
    },
    onClose() {
      this.showDialog = false
    }
  }
}
</script>

<style scoped>
.invoice-details {
  border-radius: 8px;
}
</style>